export enum ChartkitHandlers {
    DCMonitoringLabelFormatter = 'dc-monitoring-label-formatter',
    WizardLabelFormatter = 'wizard-label-formatter',
    WizardTooltipHeaderFormatter = 'wizard-tooltip-header-formatter',
    WizardManageTooltipConfig = 'wizard-manage-tooltip-config',
    WizardXAxisFormatter = 'wizard-x-axis-formatter',
    WizardExportColumnNamesFormatter = 'wizard-export-column-names-formatter',
    WizardScatterTooltipFormatter = 'wizard-scatter-tooltip-formatter',
    WizardTreemapTooltipFormatter = 'wizard-treemap-tooltip-formatter',
    WizardScatterYAxisLabelFormatter = 'wizard-scatter-y-axis-label-formatter',
    WizardDatetimeAxisFormatter = 'wizard-datetime-axis-formatter',
}

export const WRAPPED_HTML_KEY = '__wrappedHTML__';
